<template>
  <Modal title="开票" v-model="visible" width="900px">
      <Form ref="form" class="form" :model="invoiceFormData" :rules="invoiceRule">
        <Row :gutter="24">
          <i-col span="6" style="padding-left: 0;">
            <Form-item label="学生：" :label-width="80">
              <label>{{invoiceFormData.id}} -- {{invoiceFormData.nickname}}</label>
            </Form-item>
          </i-col>
          <i-col span="6">
            <Form-item label="课程顾问：" :label-width="80">
              <label>{{invoiceFormData.adviserName}}</label>
            </Form-item>
          </i-col>
          <i-col span="6">
            <Form-item label="学习导师：" :label-width="80">
              <label>{{invoiceFormData.studyAdviserName}}</label>
            </Form-item>
          </i-col>
        </Row>
        <Row :gutter="20">
          <Form-item label="开票信息：" prop="content" :label-width="80">
            <Input v-model="invoiceFormData.content" type="textarea" :rows="4" placeholder="请输入..."></Input>
          </Form-item>
        </Row>
        <Row>
          <i-col span="12">
          <Form-item label="开票时间：" :label-width="90">
            <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                         @on-change="invoiceTimeChange" :clearable="false"
                         v-model="invoiceFormData.invoiceTime"></Date-picker>
          </Form-item>
          </i-col>
          <i-col span="4">
            <Form-item label="开票金额："  prop="amount" :label-width="90">
              <Input placeholder="开票金额" v-model="invoiceFormData.amount" style="width: 120px"></Input>
            </Form-item>
          </i-col>
        </Row>
        <Row>
          <i-col span="12">
            <Form-item label="发票类型：" prop="state" :label-width="90">
              <Select v-model.number="invoiceFormData.state" style="width: 120px"   transfer>
                <Option :value="1">收据</Option>
                <Option :value="2">普通发票</Option>
                <Option :value="3">增值税发票</Option>
                <Option :value="4">服务发票</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col span="4">
            <Form-item label="发票号码："  prop="number" :label-width="90">
              <Input placeholder="发票号码" v-model="invoiceFormData.number" style="width: 120px"></Input>
            </Form-item>
          </i-col>
        </Row>
        <div style="margin: 0 0 40px 35px;">
          <Button type="primary" style="margin-left: 620px;" @click="insert" >开票</Button>
          <Button type="test" @click="callback">取消</Button>
        </div>
      </Form>
      <Row :gutter="1">
        <Tag color="yellow" style="margin-bottom: 15px">开票记录</Tag>
      </Row>
    <div slot="footer">
    </div>
      <Table border :columns="invoiceTitle" :data="invoiceData" :reload="reload"></Table> <!--:data="followData"-->
  </Modal>
</template>
<script>
  import dates from '@/tools/date/dates.js'
  export default {
    name: 'EditOrderModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      successCallback: {
        type: Function
      },
      invoiceDetail: {
        type: String,
        default: null,
      },
      uid: {
        type: Number,
        default: null,
      },
      orderId: {
        type: String,
        default: null,
      }
    },
    data () {
      let $constant = this.$constant
      return {
        visible: this.value,
        loading: false,
        reload: 0,
        orderId: null,
        invoiceData: [],
        invoiceFormData: {
          id: '',
          nickname: '',
          adviserName: '',
          studyAdviserName: '',
          tchName: '',
          content: '',
          state: '',
          number: '',
          amount: '',
          invoiceTime: '',
        },
        invoiceRule: {
          state: [
            { type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }
          ],
          amount: [
            { required: true, message: '不能为空', trigger: 'blur' }
          ],
          number: [
            { type: 'string', required: true, message: '不能为空', trigger: 'blur' }
          ],
        },
        invoiceTitle: [
          {
            title: '发票类型',
            render: (h, params) => {
              let invoiceStatus = params.row.state
              let invoiceStatusEnum = $constant.getEnum($constant.invoiceStatus, invoiceStatus)
              return h('div', invoiceStatusEnum && invoiceStatusEnum.text)
            }
          },
          {
            title: '发票号码',
            key: 'number',
          },
          {
            title: '开票金额',
            key: 'amount',
          },
          {
            title: '开票日期',
            key: 'invoiceTimeStr',
          },
          {
            title: '开票人',
            key: 'creatorName',
          },
          {
            title: '操作',
            align: 'center',
            render: (h, params) => {
              let self = this
              let row = params.row
              if (row.status === 1) {
                return h('div', [
                  h('a', {on: {click: () => self.updateStatus(row.id)}}, '作废')
                ])
              } else if (row.status === -1) {
                return '已作废'
              }
            }
          }
        ],
      }
    },
    computed: {
      editModal: {
        get: function () {
          return this.value
        },
        set: function (newValue) {
          this.onClose()
        }
      }
    },
    methods: {
      invoiceTimeChange (value) {
        this.invoiceFormData.invoiceTime = value
      },
      onClose () {
        this.$emit('on-close')
      },
      onSuccess () {
        this.$emit('on-success')
      },
      callback () {
        this.successCallback()
        this.onClose()
        this.onSuccess()
      },
      insert () {
        let self = this
        self.$refs.form.validate((valid) => {
          if (valid) {
            if (self.orderId) {
              self.$http.post('/financial/invoiceInsert', {orderId: self.orderId, amount: self.invoiceFormData.amount, state: self.invoiceFormData.state, number: self.invoiceFormData.number, content: self.invoiceFormData.content, invoiceTime: self.invoiceFormData.invoiceTime}).then(function (res) {
                if (res.data > 0) {
                  self.$http.get('/financial/userInvoiceList?orderId=' + self.orderId).then(function (res) {
                    if (res.data) {
                      self.invoiceFormData.amount = ''
                      self.invoiceFormData.state = ''
                      self.invoiceFormData.number = ''
                      self.invoiceFormData.invoiceTime = dates.today()
                      self.invoiceData = res.data
                    }
                  })
                }
              })
            }
          } else {
            self.$Message.warning('表单验证失败!')
          }
        })
      },
      updateStatus (val) {
        if (val) {
          let self = this
          self.$http.post('/financial/invoiceUpdateStatus', {id: val, status: -1, orderId: self.orderId}).then(function (res) {
            if (res.data > 0) {
              self.$http.get('/financial/userInvoiceList?orderId=' + self.orderId).then(function (res) {
                if (res.data) {
                  self.invoiceData = res.data
                }
              })
            }
          })
        }
      }
    },
    watch: {
      value (val) {
        let self = this
        this.visible = val
        if (val) {
          self.invoiceFormData.amount = ''
          self.invoiceFormData.state = ''
          self.invoiceFormData.number = ''
          self.invoiceFormData.content = ''
          self.invoiceFormData.invoiceTime = dates.today()
        }
      },
      visible (val) {
        if (val === false) {
          this.$emit('on-close', val)
        }
      },
      uid (val) {
        let self = this
        if (val) {
          self.$http.get('/saleTrace/followUp?id=' + val).then(function (res) {
            if (res.data) {
              self.invoiceFormData.id = res.data.id
              self.invoiceFormData.adviserName = res.data.adviserName
              self.invoiceFormData.nickname = res.data.nickname
              self.invoiceFormData.studyAdviserName = res.data.studyAdviserName
              self.invoiceFormData.tchName = res.data.tchName
            }
          })
        }
      },
      orderId (val) {
        let self = this
        if (val) {
          self.orderId = val
          self.$http.get('/financial/userInvoiceList?orderId=' + val).then(function (res) {
            if (res.data) {
              self.invoiceData = res.data
            }
          })
        }
      },
      invoiceDetail (val) {
        if (val) {
          this.invoiceFormData.content = val
        } else {
          this.invoiceFormData.content = ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EditInvoiceModal.vue?9ab0d5b4